var eventName = typeof(Turbolinks) !== 'undefined' ? 'turbolinks:load' : 'DOMContentLoaded';

if (!document.documentElement.hasAttribute("data-turbolinks-preview")) {
  document.addEventListener(eventName, function flash() {
    var flashData = JSON.parse(document.getElementById('shopify-app-flash').dataset.flash);

    if (flashData.notice) {
      shopify.toast.show(flashData.notice, {
        duration: 5000,
      });
    }

    if (flashData.error) {
      shopify.toast.show(flashData.error, {
        duration: 5000,
        isError: true,
      });
    }

    document.removeEventListener(eventName, flash)
  });
}
